import {Image, Square, Text} from '@chakra-ui/react';
import {colors} from 'components/providers';
import {useRouter} from 'next/router';
import {FC} from 'react';
import {IPromoCategoryResponse} from 'types';

interface IProps {
  promotion: IPromoCategoryResponse;
  isMarkets?: boolean;
}

export const PromotionTile: FC<IProps> = ({promotion, isMarkets}) => {
  const {icon, providers_count, name, slug} = promotion;
  const {push} = useRouter();

  if (!providers_count) return null;
  return (
    <Square
      flexDirection="column"
      p={['10px', '15px']}
      borderRadius="16px"
      alignItems="flex-start"
      justifyContent="space-between"
      size={['100px', '150px']}
      position="relative"
      bg={colors.lightGray}
      cursor="pointer"
      onClick={() => {
        const route = Object.entries({
          promo_type: slug,
          filters: `promo`,
          ordering: 'default',
        })
          .filter((entry) => !!entry[1])
          .map((entry) => entry.join('='))
          .join('&');
        push(`${isMarkets ? '/markets' : '/restaurants'}?${route}`);
      }}
    >
      <Text as="span" fontSize={['12px', '18px']} fontWeight="700" lineHeight={['12px', '21px']}>
        {name}
      </Text>
      <Square
        bg="#CECFD3"
        borderRadius="999px"
        size={['24px', '36px']}
        display="flex"
        justifyContent="center"
        alignItems="center"
        fontSize={['12px', '16px']}
        fontWeight="600"
      >
        {providers_count}
      </Square>
      {icon && (
        <Image
          w={['50%', '40%']}
          maxW="100px"
          position="absolute"
          right="0"
          bottom="0"
          src={icon}
          alt={`${name} icon`}
          borderBottomRightRadius="16px"
        />
      )}
    </Square>
  );
};
